export enum HistoryLogEntrySeverity {
  INFO,
  WARNING,
  ERROR,
}

/**
 * See list at https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/2558230822/Integrations+Marketplace+error+codes
 * To avoid conflicts please reserve values first by adding them to the page
 */
export enum HistoryLogEntryErrorCode {
  PARSE_ERROR = -32700,
  INTERNAL_ERROR = -32603,
  INVALID_PARAMS = -32602,
  METHOD_NOT_FOUND = -32601,
  INVALID_REQUEST = -32600,
  OK = 0,
  RUNTIME_ERROR = 1,
  SERVICE_ERROR = 2,
  NOT_PROCESSED = 3,
  SERVICE_NOT_FOUND = 4,
  INVALID_CONFIG = 5,
  INTEGRATION_NOT_FOUND = 100,
  INTEGRATION_NOT_ENABLED = 101,
  COMPANY_NOT_FOUND = 102,
  LICENSE_REQUIRED = 103,
  INTEGRATOR_ENDPOINT_NOT_FOUND = 104,
  MUTUAL_AUTHENTICATION_NOT_ENABLED = 105,
  INTEGRATOR_ENDPOINT_NOT_ASSIGNED = 106,
  DUPLICATE_INTEGRATION = 107,
  INTEGRATION_INSTANCE_MISMATCH = 108,
  NO_TOKEN_PROVIDED = 110,
  INVALID_TOKEN = 111,
  CLIENT_CERTIFICATE_REQUIRED = 112,
  UNABLE_TO_VERIFY_CLIENT_CERTIFICATE = 113,
  FINGERPRINT_MISMATCH = 114,
  INSUFFICIENT_CAPABILITIES = 115,
  CLIENT_CERTIFICATE_VERIFICATION_FAILED = 116,
  EXPIRED_TOKEN = 117,
  BAD_REQUEST = 400,
  FORBIDDEN = 403,
  METHOD_NOT_ALLOWED = 405,
  PAYLOAD_TOO_LARGE = 413,
  UNSUPPORTED_MEDIA_TYPE = 415,
  INVALID_DATA = 600,
  INTERNAL_STATE_PARSER_ERROR = 1000,
  INTERNAL_STATE_STATUS_MISMATCH = 1001,
  ROOT_VMWARE_CENTER_NOT_FOUND = 2000,
  NETWORK_PROTECTED_ENTITY_NOT_FOUND = 2001,
  EPS_PROTECTED_ENTITY_NOT_FOUND = 2002,
  INTEGRATION_VIEW_TYPE_NOT_FOUND = 2003,
  UNKNOWN_ENTITY_TYPE = 2004,
  NO_VISIBLE_PARENT_FOUND = 2005,
  ENTITY_NOT_INSERTABLE = 2006,
  ENTITY_NOT_UPDATABLE = 2007,
  NETWORK_PROCESSOR_PARSER_ERROR = 2008,
  INTEGRATION_VALIDATION_ERROR = 2009,
  INTEGRATION_REMOVED = 4001,
  PROVIDER_CONNECTION_FAILED = 4003,
  PROVIDER_CERTIFICATE_VERIFICATION_FAILED = 4004,
  PROVIDER_INVALID_REQUEST = 4005,
  PROVIDER_INVALID_RESPONSE = 4006,
  PROVIDER_API_ERROR = 4007,
  UNSUPPORTED_API_VERSION = 4008,
  LOGIN_FAILED = 4009,
  PROVIDER_RUNTIME = 4010,
  PROVIDER_INVALID_ENTITY = 4011,
  PROVIDER_INVALID_VERSION = 4012,
  PROVIDER_DATABASE_ERROR = 4013,
  SERVICE_CONNECTION_GENERIC_ERROR = 4100,
  SERVICE_CONNECTION_FAILED = 4101,
  SERVICE_HOST_RESOLVE = 4102,
  SERVICE_CONNECTION_TIMEOUT = 4103,
  SERVICE_CONNECTION_MTLS = 4104,
  SERVICE_HTTP_ERROR = 4105,
  SERVICE_UNKNOWN_ERROR = 4106,
  CONFIG_MA_NOT_ENABLED = 4116,
  CONFIG_NO_CLIENT_CERTIFICATE = 4117,
  CONFIG_COMPANY_NOT_SET = 4118,
  CONFIG_HWID_NOT_SET = 4119,
  REPORTER_RUNTIME = 4132,
  REPORTER_DATABASE_ERROR = 4133,
  POLICY_NO_MA = 4050,
  MAX_INTEGRATORS_RUNNING = 4051,
  NO_INTEGRATOR = 5000,
  INTEGRATOR_OFFLINE = 5001,
}

export interface HistoryLogEntry {
  _id: string;
  created: number;
  integrationId: string;
  companyId: string;
  integrationType: number;
  severity: HistoryLogEntrySeverity;
  errorCode: HistoryLogEntryErrorCode;
  specifics: {
    integratorId?: string;
    integratorName?: string;
    integratorFqdn?: string;
    integratorIp?: string;
  };
}

export enum HistoryLogEvents {
  CLOSE = 'close',
  CLEAR_LOGS = 'clearLogs',
}

export interface Dependencies {
  api: {
    type: string;
  };
  getTimezone: Function;
}
